///
/// EarthBrowser
///
/// Migration v8 to v9: Add location focus panel state to userInterface
///
/// This migration adds the locationFocusPanel field to the userInterface slice
/// for managing the DOM-based location focus panel.
///

interface StateV8 {
	userInterface?: {
		locationFocusPanel?: unknown
	}
}

/**
 * Migration from version 8 to 9: Add location focus panel state
 * - Adds locationFocusPanel with default values to userInterface
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV8toV9(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV8
	const oldUserInterface = s.userInterface || {}

	// Create new userInterface state with locationFocusPanel
	const newUserInterface = {
		...oldUserInterface,
		locationFocusPanel: oldUserInterface.locationFocusPanel ?? {
			isOpen: false,
			position: { x: 100, y: 100 },
			locationInfo: null,
			countryName: null
		}
	}

	// Return completely new state object
	return {
		...s,
		userInterface: newUserInterface
	}
}
